import { render, staticRenderFns } from "./SalePaymentGroupForm.vue?vue&type=template&id=13c16a30"
import script from "./SalePaymentGroupForm.vue?vue&type=script&lang=js"
export * from "./SalePaymentGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports